import React, { HTMLAttributes, ElementType } from 'react';
import { ArrayUnitValue, Media, UnitValue } from '../../types';

import { BoxEmotion } from './styles';
import {
  Display,
  JustifyContent,
  AlignItems,
  FlexGrow,
  FlexShrink,
  FlexDirection,
  FlexWrap,
  TextAlign,
  AlignSelf,
  AlignContent
} from './types';

export interface Props extends HTMLAttributes<HTMLElement> {
  as?: ElementType;
  width?: UnitValue | Media<UnitValue>;
  minWidth?: UnitValue | Media<UnitValue>;
  maxWidth?: UnitValue | Media<UnitValue>;
  height?: UnitValue | Media<UnitValue>;
  minHeight?: UnitValue | Media<UnitValue>;
  maxHeight?: UnitValue | Media<UnitValue>;
  marginLeft?: UnitValue | Media<UnitValue>;
  marginRight?: UnitValue | Media<UnitValue>;
  marginTop?: UnitValue | Media<UnitValue>;
  marginBottom?: UnitValue | Media<UnitValue>;
  margin?: ArrayUnitValue | Media<ArrayUnitValue>;
  paddingLeft?: number | Media<number>;
  paddingRight?: number | Media<number>;
  paddingTop?: number | Media<number>;
  paddingBottom?: number | Media<number>;
  padding?: [number, number?, number?, number?] | Media<[number, number?, number?, number?]>;
  display?: Display | Media<Display>;
  justifyContent?: JustifyContent | Media<JustifyContent>;
  alignItems?: AlignItems | Media<AlignItems>;
  alignContent?: AlignContent | Media<AlignContent>;
  alignSelf?: AlignSelf | Media<AlignSelf>;
  flexBasis?: UnitValue | Media<UnitValue>;
  flexGrow?: FlexGrow | Media<FlexGrow>;
  flexShrink?: FlexShrink | Media<FlexShrink>;
  flexDirection?: FlexDirection | Media<FlexDirection>;
  flexWrap?: FlexWrap | Media<FlexWrap>;
  textAlign?: TextAlign | Media<TextAlign>;
  lineHeight?: number | Media<number>;
}

export const Box: React.FC<Props> = props => <BoxEmotion {...props}>{props.children}</BoxEmotion>;
